@import (reference) '../../../../../../../constants/spacing.module.less';

.card {
  background: var(--light--background-color--1);
  border: 1px solid var(--default--border-color--12);
  border-radius: 8px;
  overflow: hidden;
}

.card-header {
  padding: @space-16;
  border-bottom: 1px solid var(--default--border-color--12);
}

.card-body {
  padding: @space-16;
}

.detail-label {
  color: var(--default--text-color--9);
}

.status-badge {
  display: inline-block;
  width: fit-content;
  padding: @space-4 @space-8;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
}

.status-booked {
  background: var(--success--icon--fill-color--1);
  color: #fff;
}

.status-cancelled {
  background: var(--error--icon--fill-color--1);
  color: #fff;
}

.bol-value {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.document-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @space-8 0;
  border-bottom: 1px solid var(--default--border-color--10);
}

.document-row:last-child {
  border-bottom: none;
}

.document-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.address-block {
  padding-bottom: @space-8;
}

.handling-unit-block {
  padding-bottom: @space-8;
  border-bottom: 1px solid var(--default--border-color--10);
}

.handling-unit-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
